import { SingleTaxDetails } from '@dealstack/frontend/shared/components/SingleTaxDetails/SingleTaxDetails';
import { groupedSelectDividerStyles } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { COUNTRIES_NAME_CODE_GROUPED_OPTIONS } from '@dealstack/shared/lib/countries/countriesData';
import { Button, Flex, Text } from '@mantine/core';
import { Select } from 'react-hook-form-mantine';
import styled from 'styled-components';

import { taxResidenceFieldName } from './taxResidences.utils';

interface Props {
	index: number;
	showTin: boolean;
	disabled?: boolean;
	initialTaxResidency?: string;
	initialTin?: string;
	onRemove?: () => void;
}

export const TaxResidenceEntryFields = ({
	index,
	showTin,
	disabled,
	initialTaxResidency,
	initialTin,
	onRemove,
}: Props) => {
	const tInvestor = useTranslationInvestor();

	return (
		<EntryCard>
			<Flex justify="space-between" align="center" mb="0.5rem">
				<Text size="B5Bold">
					{tInvestor('investment.personal_details.tax_residences.entry_title', {
						number: index + 1,
						defaultValue: 'Tax residence {{number}}',
					})}
				</Text>
				{onRemove && (
					<Button variant="subtle" color="red" onClick={onRemove}>
						{tInvestor('investment.personal_details.tax_residences.remove', {
							defaultValue: 'Remove',
						})}
					</Button>
				)}
			</Flex>

			{showTin ? (
				<SingleTaxDetails
					withHeader={false}
					disabled={disabled}
					initialTaxResidency={initialTaxResidency}
					initialTin={initialTin}
					taxResidencyFieldName={taxResidenceFieldName(index, 'taxResidency')}
					tinFieldName={taxResidenceFieldName(index, 'tin')}
				/>
			) : (
				<Select
					name={taxResidenceFieldName(index, 'taxResidency')}
					label={tInvestor('investment.personal_details.tax_residency')}
					placeholder={tInvestor('investment.personal_details.tax_residency')}
					data={COUNTRIES_NAME_CODE_GROUPED_OPTIONS}
					searchable
					size="md"
					disabled={disabled}
					styles={groupedSelectDividerStyles}
				/>
			)}
		</EntryCard>
	);
};

const EntryCard = styled(Flex)`
	padding: 1rem;
	flex-direction: column;
	gap: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.5rem;
`;
